import { ColumnsType } from "antd/es/table";
import React, { useEffect, useState } from "react";
import CustomTable from "src/components/custom-table/custom-table";
import Loading from "src/components/loading/loading.component";
import instance from "src/store/axios";

const UsersList = ({ notificationId }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [pages, setPages] = useState<number>(1);

  useEffect(() => {
    getNotificationUsers();
  }, [notificationId]);

  const getNotificationUsers = async (page = 1) => {
    setLoading(true);
    try {
      const response = await instance.get(
        `${process.env.REACT_APP_ENDPOINT_VERSION}/notification/${notificationId}/users?page=${page}`
      );
      setUsers(response.data?.data?.users);
      setPages(response.data?.data?.pagination?.pages);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const columns: ColumnsType<Notification> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      render: (_, __, index: number) => <span>{index + 1}</span>,
    },
    {
      title: "User",
      dataIndex: "name",
      key: "name",

      render: (text: string, record: any) => (
        <div className="flex flex-col gap-1">
          {record?.user?.firstName} {record?.user?.lastName}
        </div>
      ),
    },
    {
      title: "Phone",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      render: (text: string, record: any) => (
        <div className="flex flex-col gap-1">{record?.user?.phoneNumber}</div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text: string, record: any) => (
        <div className="flex flex-col gap-1">{record?.user?.email}</div>
      ),
    },
  ];

  return (
    <div className="p-4 w-full flex flex-col gap-5 min-w-[600px]">
      <div className="self-stretch h-6 text-center justify-center text-zinc-800 text-xl font-bold font-['Montserrat']">
        User list
      </div>
      {loading && <Loading />}
      <CustomTable
        columns={columns}
        data={users}
        showPagination={true}
        pageSize={20}
        totalCount={pages * 20}
        // page={notificationlist?.currentPage}
        onPageChange={(page) => {
          getNotificationUsers(page);
        }}
      />
    </div>
  );
};

export default UsersList;
